import React from "react";

function ScrollToTop() {
  return (
    <div>
      <button id="scrollTopButton" className="lawgis-scrolltop scrolltop-hide">
        <i className="ti ti-arrow-up"></i>
      </button>
    </div>
  );
}

export default ScrollToTop;
